import React from 'react'

import type {FileTag} from '@/shared/utils/crud-helper/models'

interface FileTagChipProps {
  tag: FileTag
  /** Omit for a read-only chip (a sent prompt's bubble). */
  onRemove?: (id: string) => void
}

interface ChipLook {
  variant: string
  icon: string
  label: string
  title: string
}

function chipLook(tag: FileTag): ChipLook {
  if (tag.type === 'job') {
    return {
      variant: 'job',
      icon: 'fas fa-gears',
      label: `Job: ${tag.name}`,
      title: `Job run ${tag.runId}${tag.tool ? ` (${tag.tool})` : ''}`,
    }
  }
  if (tag.source === 'result') {
    return {
      variant: 'result',
      icon: 'fas fa-chart-simple',
      label: `Results: ${tag.name}`,
      title: `From Results: ${tag.cloudPath}`,
    }
  }
  return {
    variant: tag.type,
    icon: tag.type === 'folder' ? 'fas fa-folder' : 'fas fa-file',
    label: tag.name,
    title: tag.cloudPath,
  }
}

/** One attachment chip (file, folder, Results tab or job): the composer's and a sent prompt's. */
export const FileTagChip: React.FC<FileTagChipProps> = ({tag, onRemove}) => {
  const {variant, icon, label, title} = chipLook(tag)
  return (
    <span className={`file-tag file-tag--${variant}`} title={title}>
      <i className={icon} />
      <span className='file-tag__name'>{label}</span>
      {onRemove ? (
        <button
          type='button'
          className='file-tag__remove'
          onClick={() => onRemove(tag.id)}
          title='Remove'
        >
          <i className='fas fa-xmark' />
        </button>
      ) : null}
    </span>
  )
}
